import { Helmet } from "react-helmet-async";
import { useEffect, useState } from "react";
import { useSiteBase, hotelSchema } from "../lib/SEOHead";
import { client } from "../lib/config";

export default function SiteSchema() {
  const { base } = useSiteBase();
  const [reviews, setReviews] = useState(null);
  useEffect(() => {
    client.get("/reviews").then((r) => setReviews(r.data)).catch(() => {});
  }, []);
  const schema = hotelSchema(base);
  if (reviews && reviews.source === "google" && reviews.rating && reviews.review_count) {
    schema.aggregateRating = {
      "@type": "AggregateRating",
      "ratingValue": reviews.rating,
      "reviewCount": reviews.review_count,
      "bestRating": 5,
      "worstRating": 1,
    };
  }
  return (
    <Helmet>
      <script type="application/ld+json">{JSON.stringify(schema)}</script>
    </Helmet>
  );
}
